import React from 'react'

const Loading = () => {
 return (
  <div>
   <h1 className="text-primary">
   Loading in progress please wait..........
   </h1>
  </div>
 )
}

export default Loading
